import React from 'react';
import { motion } from 'framer-motion';
import { Building2, UploadCloud, FileBarChart } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    number: '1',
    title: 'Creamos tu obra en la plataforma',
    icon: <Building2 className="w-8 h-8 text-blue-600" data-id="element-138" />
  }, {
    number: '2',
    title: 'Subes el archivo del chat de WhatsApp (o lo conectamos directo)',
    icon: <UploadCloud className="w-8 h-8 text-blue-600" data-id="element-139" />
  }, {
    number: '3',
    title: 'Recibes resúmenes, reportes y acceso filtrable. Sin esperar.',
    icon: <FileBarChart className="w-8 h-8 text-blue-600" data-id="element-140" />
  }];
  return <section id="como-funciona" className="py-12 sm:py-16 bg-white" data-id="element-141">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-142">
        <div className="text-center mb-12 sm:mb-16" data-id="element-143">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900" data-id="element-144">
            Así de simple
          </h2>
        </div>

        <div className="relative" data-id="element-145">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-10 left-0 w-full h-0.5 bg-gray-200 z-0" data-id="element-146"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 sm:gap-12 relative z-10" data-id="element-147">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="flex flex-col items-center text-center" data-id="element-148">
                <div className="relative mb-6" data-id="element-149">
                  <div className="w-20 h-20 bg-white rounded-2xl border-2 border-gray-100 shadow-sm flex items-center justify-center" data-id="element-150">
                    {step.icon}
                  </div>
                  <div className="absolute -top-3 -right-3 w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-sm border-2 border-white shadow-sm" data-id="element-151">
                    {step.number}
                  </div>
                </div>
                <h3 className="text-lg font-bold text-gray-900 max-w-[260px] leading-snug" data-id="element-152">
                  {step.title}
                </h3>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-16 sm:mt-20 px-4" data-id="element-153">
          <p className="text-xl sm:text-2xl font-bold text-gray-900 inline-block relative" data-id="element-154">
            Cero apps nuevas. Cero capacitación. Funciona con el WhatsApp que ya
            usas.
            <span className="absolute -bottom-2 left-0 w-full h-2 bg-blue-500 rounded-full opacity-20" data-id="element-155"></span>
          </p>
        </motion.div>
      </div>
    </section>;
}